import { AuthenticatedHttpClient } from "@/lib/axios";
import { ApiKey } from "@/types/apikey.types";
import { PaginatedResponse } from "@/types/common";
import { ILabel } from "@/types/label.types";

export class ApiKeyService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  // Get all labels with pagination
  async getApiKeys() {
    const response = await this.http.get(`/api-key`);
    return response as unknown as ApiKey[];
  }

  // Create new label
  async createApiKey(data: {
    name: string;
    description: string;
  }): Promise<ApiKey> {
    const response = await this.http.post<ApiKey>("/api-key", data);
    return response as unknown as ApiKey;
  }

  // Delete api key
  async deleteApiKey(id: string): Promise<void> {
    await this.http.delete(`/api-key/${id}`);
  }

  // Toggle api key status
  async activateApiKey(id: string): Promise<void> {
    await this.http.patch(`/api-key/${id}/activate`);
  }

  // Deactivate api key
  async deactivateApiKey(id: string): Promise<void> {
    await this.http.patch(`/api-key/${id}/deactivate`);
  }
}
